import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.css'; // Import the global CSS
import 'flexslider/flexslider.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

createApp(App)
  .use(router)  // Register the router
  .mount('#app');  // Mount the app

// Create the app instance
//const app = createApp(App);

// Use the VueCarousel plugin
//app.use(VueCarousel);

// Mount the app to the DOM
//app.mount('#app');
